import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker() (CRA's default) caches the app shell (index.html +
// JS/CSS) in the service worker's own Cache Storage, separate from any HTTP/
// CDN cache - a normal page load then keeps getting served the PREVIOUS
// deploy's bundle from that cache ("developers/users will only see updates on
// the N+1 visit", per registerServiceWorker.js's own comment) until the new
// worker takes over. That's what made a bug fix appear only after a hard
// reload. This app has no offline/PWA requirement, so unregister() instead -
// removes any previously-installed worker (and stops new ones from being
// installed), so every load just does normal HTTP fetches.
unregister();
